document.querySelectorAll('[data-resource-library]').forEach((library) => {
  if (library.dataset.ready) return;
  library.dataset.ready = 'true';
  const cards = [...library.querySelectorAll('[data-resource-card]')];
  let format = 'all', access = 'all';
  const update = () => {
    let count = 0;
    cards.forEach(card => {
      card.hidden = !((format === 'all' || card.dataset.format === format) && (access === 'all' || card.dataset.access === access));
      if (!card.hidden) count++;
    });
    library.querySelectorAll('[data-format-filter]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.formatFilter === format)));
    library.querySelectorAll('[data-access-filter]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.accessFilter === access)));
    library.querySelector('.cotw-resource-count').textContent = count + (count === 1 ? ' resource' : ' resources');
    library.querySelector('.cotw-resource-empty').hidden = count > 0;
  };
  library.querySelector('.cotw-resource-filters').hidden = false;
  library.addEventListener('click', event => {
    const button = event.target.closest('button');
    if (!button) return;
    if (button.hasAttribute('data-format-filter')) format = button.dataset.formatFilter;
    else if (button.hasAttribute('data-access-filter')) access = button.dataset.accessFilter;
    else if (button.hasAttribute('data-reset-filters')) { format = 'all'; access = 'all'; }
    else return;
    update();
  });
  update();
});
